"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
// Export data
var _default = exports.default = {
  domain: '',
  learnMore: {
    logo: {
      alt: 'SAP Logo',
      src: '/sites/all/modules/custom_concur/concur_sap_banner/images/sap-logo.png'
    },
    text: 'Concur is an SAP Company',
    learn: {
      href: '/sap',
      text: '더 알아보기'
    }
  },
  social: [{
    network: 'facebook',
    href: ''
  }, {
    network: 'twitter',
    href: ''
  }, {
    network: 'linkedin',
    href: ''
  }],
  support: {
    links: [{
      text: '블로그',
      href: ''
    }, {
      text: '문의',
      href: '/contact'
    }],
    selector: '국가 / 지역 선택',
    modelTitle: 'Select your location:'
  },
  copyright: {
    text: '© Copyright @{year} Concur Technologies, Inc. All rights reserved.',
    links: [{
      text: '개인 정보 정책',
      href: '/privacy-policy'
    }, {
      text: '사용 조건',
      href: ''
    }]
  }
};